<mad-data-table
  [displayedColumns]="displayedColumns"
  [tableData]="tableData"
  [loading]="loading"
  [page]="page"
  [paginationEnabled]="true"
  [useAsync]="true"
  (sortEvent)="handleSortEvent($event)"
  (pageEvent)="handlePageEvent($event)"
>
</mad-data-table>
